import React from 'react';
import hard1 from '../../../../assets/img/desktop/hardware.jpg';
import hard2 from '../../../../assets/img/desktop/Nuestros_Partners.jpg';
import './CDHardware.css';

function CDHardware() {

    return (
        <main id="CDHardware">
            <section id="CDHW-c1">
                <h2>Distribución de Hardware</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Distribución de Hardware</li>
                </ul>
            </section>
            <section id="CDHW-c2">
                <figure id="CDHW-c2__image">
                    <img src={hard1} />
                </figure>
                <div id="CDHW-c2__text">
                    <h4>En <strong>INFRASOL</strong> somos distribuidores oficiales de las <strong>mejores</strong> marcas.</h4>
                    <p>Ofrecemos soluciones confiables, de alto rendimiento y con garantía certificada. Proveemos equipamiento tecnológico de calidad empresarial, incluyendo servidores, estaciones de trabajo, equipos de usuario final, periféricos y suministros, adaptados a las necesidades operativas y presupuestales de cada organización.</p>
                </div>
            </section>
            <section id="CDHW-c3">
                <div id="CDHW-c3__text">
                    <h2>Hardware alineado a los <strong>tiempos actuales.</strong></h2>
                    <p>La evolución constante de las empresas exige la renovación periódica de los parques informáticos y de los sistemas de comunicación. En INFRASOL analizamos y evaluamos soluciones de hardware, software y metodologías de trabajo para asesorar a nuestros clientes en la adopción de tecnologías confiables y contrastadas, compatibles con su infraestructura actual, escalables para el crecimiento futuro y acordes a las demandas tecnológicas actuales.</p>
                </div>
                <div id="CDHW-c3__image">
                    <figure>
                        <img src={hard2} />
                    </figure>
                    <p><strong>¿Necesitas una cotización?</strong> Para cualquier solicitud de cotización o asesoría, contáctanos a través del botón de WhatsApp o mediante el menú Contacto.</p>
                </div>
            </section>
        </main>
    );
}

export default CDHardware;